import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { acceptInvitation as acceptInvitationService } from '../../../services/user/UserService';

interface Values {
  isLoading: boolean;
  acceptInvitation: (invitationId: string) => Promise<number>;
}

const useAcceptInvitation = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const acceptInvitation = async (invitationId: string): Promise<number> => {
    try {
      setIsLoading(true);
      const result = await acceptInvitationService(invitationId);
      if (result.data === 1) {
        setIsLoading(false);
        return 1;
      } else {
        setIsLoading(false);
        return 0;
      }
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return 0;
    }
  };

  return { acceptInvitation, isLoading };
};

export default useAcceptInvitation;
